/*
 *  See:  https://github.com/joelewis/prosemirror-mentions
 */

export { getMentionsPlugin } from './mentionPlugin';
export { addMentionNodes, addTagNodes } from './utils';
export { tagNode, mentionNode } from './nodes';
